import { atom } from "recoil";
import { localStorageEffect } from "../utils/localStorageEffect";

export const isMobileState = atom({
  key: "isMobileState",
  default: false,
  effects_UNSTABLE: [localStorageEffect("isMobileState")],
});
